import { makeStyles } from '@material-ui/styles';
import { colors, fonts } from 'components/styles/variables';

export const useStyles = makeStyles({
  saveSearchButton: {
    '&.MuiButton-root': {
      backgroundColor: colors.ALR1,
    },
    '&.MuiButton-text': {
      color: colors.WHITE,
    },
    '&:hover': {
      backgroundColor: colors.ALR2,
    },
    '&:disabled': {
      opacity: 0.5,
    },
    '&.MuiButton-root:hover.Mui-disabled': {
      backgroundColor: colors.ALR1,
    },
    fontFamily: fonts.default,
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.2px',
    textTransform: 'none',
    width: 'calc((100% - 48px) / 2)',
    borderRadius: '4px',
  },
});
